import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, ChevronRightIcon, MonitorIcon, SmartphoneIcon } from 'lucide-react';
export function SettingsSecurity() {
  const navigate = useNavigate();
  const [twoFA, setTwoFA] = useState(false);
  const sessions = [{
    icon: SmartphoneIcon,
    name: 'iPhone 15 Pro',
    location: 'San Francisco, CA',
    current: true
  }, {
    icon: MonitorIcon,
    name: 'MacBook Pro',
    location: 'San Francisco, CA',
    current: false
  }, {
    icon: SmartphoneIcon,
    name: 'iPad',
    location: 'New York, NY',
    current: false
  }];
  return <div className="w-full h-full bg-black flex flex-col" data-id="element-638">
      <div className="px-4 py-4 flex items-center border-b border-border sticky top-0 bg-black z-10" data-id="element-639">
        <button onClick={() => navigate(-1)} className="text-white mr-4" data-id="element-640">
          <ArrowLeftIcon size={24} data-id="element-641" />
        </button>
        <h1 className="text-white font-poppins font-bold text-lg" data-id="element-642">Security</h1>
      </div>

      <div className="flex-1 overflow-y-auto no-scrollbar pb-8" data-id="element-643">
        <div className="bg-surface border-y border-border mt-6" data-id="element-644">
          <button onClick={() => navigate('/auth/reset')} className="w-full px-4 py-4 flex items-center justify-between hover:bg-surface2 transition-colors border-b border-border" data-id="element-645">
            <span className="text-white text-sm font-medium" data-id="element-646">
              Change password
            </span>
            <ChevronRightIcon size={16} className="text-softGray" data-id="element-647" />
          </button>

          <div className="px-4 py-4 flex items-center justify-between" data-id="element-648">
            <div data-id="element-649">
              <p className="text-white text-sm font-medium" data-id="element-650">
                Two-factor authentication
              </p>
              <p className="text-softGray text-xs mt-0.5" data-id="element-651">
                Add extra security to your account
              </p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-652">
              <input type="checkbox" className="sr-only peer" checked={twoFA} onChange={() => setTwoFA(!twoFA)} data-id="element-653" />
              <div className="w-11 h-6 bg-surface2 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary" data-id="element-654" />
            </label>
          </div>
        </div>

        <h2 className="px-4 text-softGray text-xs font-bold uppercase tracking-wider mb-2 mt-6" data-id="element-655">
          Active sessions
        </h2>
        <div className="bg-surface border-y border-border" data-id="element-656">
          {sessions.map((s, i) => <div key={i} className={`px-4 py-4 flex items-center gap-3 ${i !== sessions.length - 1 ? 'border-b border-border' : ''}`} data-id="element-657">
              <div className="w-10 h-10 rounded-full bg-surface2 flex items-center justify-center text-softGray" data-id="element-658">
                <s.icon size={18} data-id="element-659" />
              </div>
              <div className="flex-1" data-id="element-660">
                <p className="text-white text-sm font-medium flex items-center gap-2" data-id="element-661">
                  {s.name}
                  {s.current && <span className="text-[10px] text-primary font-bold" data-id="element-662">
                      CURRENT
                    </span>}
                </p>
                <p className="text-softGray text-xs mt-0.5" data-id="element-663">{s.location}</p>
              </div>
              {!s.current && <button className="text-neonOrange text-xs font-bold" data-id="element-664">
                  End
                </button>}
            </div>)}
        </div>
      </div>
    </div>;
}